import { PasoCooler } from './PasoCooler';
import { PasoDisco } from './PasoDisco';
import { PasoPerifericos } from './PasoPerifericos';
import { PasoFuente } from './PasoFuente';
import { PasoGabinete } from './PasoGabinete';
import { PasoMemoria } from './PasoMemoria';
import { PasoMonitor } from './PasoMonitor';
import { PasoMother } from './PasoMother';
import { PasoVideo } from './PasoVideo';
import { PasoProcesador } from './PasoProcesador';
import { DatosArmado } from '@core/models/datosArmado';

const pasosBarraLateral = new DatosArmado(
  new PasoProcesador(),
  new PasoMother(),
  new PasoCooler(),
  new PasoMemoria(),
  new PasoVideo(),
  new PasoDisco(),
  new PasoFuente(),
  new PasoGabinete(),
  new PasoMonitor(),
  new PasoPerifericos(),
);

export default pasosBarraLateral;
